import jsonp from "common/js/jsonp.js"
import {commonParams,options,hostUrl} from './config.js'
import axios from 'axios'

const debug = process.env.NODE_ENV !== 'production'

export function getHome(lang) {
	const url = '/api/getHome';
	const data = {lang:lang}
	return axios.get(url, {
	    params: data
	}).then((res) => {
	    return Promise.resolve(res.data)
	})
}

export function getMenu(lang) {
	const url = '/api/getMenu'
	const data = {lang:lang}
	return axios.get(url,{
		params:data
	}).then((res) => {
		return Promise.resolve(res.data)
	})
}




// WEBPACK FOOTER //
// ./src/api/home.js